import { useEffect, useState } from 'react';
import { data_from_server_post } from '@/shared/http/client';

/**
 * Distinct tool names called anywhere in the tab's agentic trajectories
 * (`trajectory[*].tool_call.name`), powering the Data Editor's TOOLS CALLED
 * checkbox column filter (same design as Sample Origin; multi-select is OR).
 *
 * Fetched lazily — only for agentic tasks (`enabled`) — and re-fetched when
 * the task or the dataset/benchmark tab changes.
 */
export function useToolCallFilterValues(currentUsecase, isBenchmark, enabled) {
    const [values, setValues] = useState([]);
    const clientId = currentUsecase?.client_id;
    const usecaseId = currentUsecase?._id;

    useEffect(() => {
        if (!enabled || !clientId || !usecaseId) return undefined;
        let cancelled = false;
        data_from_server_post(
            'dataset-records/tool-call-names',
            {
                client_id: clientId,
                llm_usecase_id: usecaseId,
                is_benchmark: Boolean(isBenchmark),
            },
            (result) => {
                if (cancelled) return;
                setValues(Array.isArray(result?.values) ? result.values : []);
            },
            () => {
                if (cancelled) return;
                setValues([]);
            }
        );
        return () => {
            cancelled = true;
        };
    }, [enabled, clientId, usecaseId, isBenchmark]);

    return values;
}
